import { render, staticRenderFns } from "./BaseLoading.vue?vue&type=template&id=066b664c&scoped=true&"
import script from "./BaseLoading.vue?vue&type=script&lang=ts&"
export * from "./BaseLoading.vue?vue&type=script&lang=ts&"
import style0 from "./BaseLoading.vue?vue&type=style&index=0&id=066b664c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066b664c",
  null
  
)

export default component.exports